module.exports = __webpack_public_path__ + "img/gift_bag2.80ebc916.png";